module.exports = __webpack_public_path__ + "img/capacitor.7f5285db.svg";